import { render, staticRenderFns } from "./discussion.vue?vue&type=template&id=129385cc&scoped=true"
import script from "./discussion.vue?vue&type=script&lang=js"
export * from "./discussion.vue?vue&type=script&lang=js"
import style0 from "./discussion.vue?vue&type=style&index=0&id=129385cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129385cc",
  null
  
)

export default component.exports